const LAUNCH_PARAM_KEYS = ["code", "token"];

function credentialFromParams(params) {
  const code = params.get("code")?.trim();
  if (code) {
    return { code };
  }
  const token = params.get("token")?.trim();
  if (!token) {
    return null;
  }
  return { token };
}

/** Query string that was appended after `#`, e.g. `#dashboard?code=abc`. */
function hashQueryParams(hash) {
  const raw = hash.startsWith("#") ? hash.slice(1) : hash;
  const queryIndex = raw.indexOf("?");
  if (queryIndex < 0) {
    return new URLSearchParams();
  }
  return new URLSearchParams(raw.slice(queryIndex + 1));
}

function hashWithoutLaunchParams(hash) {
  const raw = hash.startsWith("#") ? hash.slice(1) : hash;
  const queryIndex = raw.indexOf("?");
  if (queryIndex < 0) {
    return hash;
  }
  const path = raw.slice(0, queryIndex);
  const params = new URLSearchParams(raw.slice(queryIndex + 1));
  for (const key of LAUNCH_PARAM_KEYS) {
    params.delete(key);
  }
  const rest = params.toString();
  return rest ? `#${path}?${rest}` : path ? `#${path}` : "";
}

/**
 * Read TutorCloud → TEMA launch params.
 * Prefer one-time `code` (default TEMA_LAUNCH_MODE=code); fall back to legacy `token`.
 * The search string wins. A code placed after `#` is still accepted so a hashed
 * TEMA_URL cannot leave the previous account signed in.
 */
export function readLaunchParams() {
  const fromSearch = credentialFromParams(new URLSearchParams(window.location.search));
  if (fromSearch) {
    return fromSearch;
  }
  return credentialFromParams(hashQueryParams(window.location.hash));
}

export function clearLaunchParamsFromUrl() {
  const url = new URL(window.location.href);
  for (const key of LAUNCH_PARAM_KEYS) {
    url.searchParams.delete(key);
  }
  url.hash = hashWithoutLaunchParams(url.hash);
  const next = `${url.pathname}${url.search}${url.hash}`;
  window.history.replaceState(null, "", next);
}
